import styled from "styled-components";
import { ChangeEvent, useMemo } from "react";
import CheckboxField from "../../../../shared/CheckboxField";
import Mk1Typography from "../../../../shared/Mk1Typography";
import { useTranslation } from "../../../../../i18n";

interface Props {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  className?: string;
}

const SearchForPackagesCheckbox = ({ isChecked, onChange, className }: Props) => {
  const { t } = useTranslation();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked);

  const checkboxLabel = useMemo(() => {
    return (
      <CheckboxLabel>
        <span>{t("tix_search_form_search_for_packages_checkbox_text")}</span>
        <Pill>{t("tix_search_form_search_for_packages_checkbox_pill_text")}</Pill>
      </CheckboxLabel>
    );
  }, [t]);

  return (
    <CheckboxField
      checked={isChecked}
      onChange={handleChange}
      label={checkboxLabel}
      name="switch_to_package"
      className={className}
    />
  );
};

const Pill = styled(Mk1Typography)`
  box-sizing: border-box;
  background: #009d73;
  color: #fff;
  height: 24;
  font-size: 14px;
  line-height: 100%;
  padding: 5px 15px;
  border-radius: 50px;
`;

const CheckboxLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  & > span:first-child {
    margin-top: 1px;
  }
`;

export default SearchForPackagesCheckbox;
